import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import MuiAccordion, {
  AccordionProps as MuiAccordionProps,
} from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';

import { Icon } from './Icon';
import { Typography } from './Typography';

interface AccordionProps extends MuiAccordionProps {
  label: React.ReactNode;
  bgcolor?: React.ReactNode;
  expandedMargin?: boolean;
}

export const Accordion: React.FC<AccordionProps> = ({
  label,
  sx,
  children,
  bgcolor,
  defaultExpanded,
  expandedMargin = false,
  ...props
}) => {
  const styles = [
    { bgcolor, '&.Mui-expanded::before': { opacity: 1 } },
    expandedMargin === false && { '&.Mui-expanded': { my: 0 } },
  ];

  return (
    <MuiAccordion
      {...props}
      sx={[...styles, ...(Array.isArray(sx) ? sx : [sx])]}
      defaultExpanded={defaultExpanded}
      slotProps={{ transition: { unmountOnExit: true, mountOnEnter: true } }}
    >
      <MuiAccordionSummary
        expandIcon={
          <Icon icon={faAngleDown} />
        }
      >
        <Typography component="div" width="100%">
          {label}
        </Typography>
      </MuiAccordionSummary>
      <MuiAccordionDetails>{children}</MuiAccordionDetails>
    </MuiAccordion>
  );
};
